import { MarketResearchSearchCriteria } from "../features";

const storageKey = "marketResearch:recent";

export const getRecentSearches = (): MarketResearchSearchCriteria[] =>
    JSON.parse(localStorage.getItem(storageKey) || "[]");

export const saveRecentSearch = (criteria: MarketResearchSearchCriteria) => {
    if (
        !criteria ||
        !criteria?.jobName ||
        !criteria?.locationId ||
        !criteria.locationName
    )
        return;

    const recentSearches = JSON.parse(localStorage.getItem(storageKey) || "[]");

    const latestSearch: MarketResearchSearchCriteria = {
        jobName: criteria.jobName,
        locationName: criteria.locationName,
        locationId: criteria.locationId,
    };

    if (!criteria?.jobName && !criteria?.locationId && !criteria.locationName)
        return;

    const existingRecentSearchIndex = recentSearches.findIndex(
        (x: MarketResearchSearchCriteria) =>
            x.jobName.trim().toLowerCase() ===
                latestSearch.jobName?.trim().toLowerCase() &&
            x.locationId === latestSearch?.locationId &&
            x.locationName.trim().toLowerCase() ===
                latestSearch.locationName.trim().toLowerCase()
    );

    //if the latest configuration is already in the list, we move it to the front of the list
    if (existingRecentSearchIndex !== -1) {
        recentSearches.unshift(
            recentSearches.splice(existingRecentSearchIndex, 1)[0]
        );
        //else we add it
    } else {
        recentSearches.unshift(latestSearch);
    }

    if (recentSearches.length > 5) {
        recentSearches.pop();
    }

    localStorage.setItem(storageKey, JSON.stringify(recentSearches));
};
